import { removeCache } from '@/utils/cache/local'
import { useNavHistory } from '@/stores/modules/routerNav'
import { usePermissionStore } from '@/stores/modules/permission'
import { usePageCache } from '@/hooks/usePageCache'

export const clearMemory = () => {
  const permissionStore = usePermissionStore()
  const navHistory = useNavHistory()
  const { removeAll } = usePageCache()
  // 清除页面缓存
  removeAll()
  removeCache('workbench')
  removeCache('isBuyZzy')
  // removeCache('token')  // TODO: 此处注释掉，同时打开两个页签，登录同一个账号会有问题
  navHistory.setHistory([])
  // 清除子系统缓存
  permissionStore.clearCache()
  // 清除掉ERP的session
  sessionStorage.removeItem('ErpProecudtBelong')
  sessionStorage.removeItem('ErpGuarantee')
}
